import React, { Component } from "react";

export class Registrar extends Component {
  componentDidMount () {
    const {
      history
    } = this.props;

    history.push("/");
  }

  render () {
    return null;
  }
}
